module.exports = require("./or.d.ts");